import { useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Popover } from '@cancercentrum/rcc-bootstrap';
import type { RowModel } from '@cancercentrum/rcc-react';
import { useIncaForm } from '@cancercentrum/rcc-react';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import type { GridRemoveIconProps } from '../../components/GridRemoveIcon.tsx';
import { GridRemoveIcon } from '../../components/GridRemoveIcon.tsx';
import usePDL from '../../pdl/usePDL.ts';

export interface PDLGridRemoveIconProps extends GridRemoveIconProps {
    row: RowModel;
}

const helpStyle = { cursor: 'help' };

export const PDLGridRemoveIcon = (props: PDLGridRemoveIconProps) => {
    const { row } = props;
    const pdlContext = usePDL();
    const id = useId();
    const dataRowOwnerId = row.$extra.dataRowOwnerPositionId;
    const contributingPosition = pdlContext.positions.find(x => x.id === dataRowOwnerId);
    const inca = useIncaForm();
    const isReadOnly = !!row.id && !inca.form.metadata[row.$rcc.tableName].allowDataRowDeletionIfPDLAccess && dataRowOwnerId !== pdlContext.currentUser.position.id;

    if (!isReadOnly) {
        return <GridRemoveIcon {...props} />;
    }

    if (!contributingPosition) {
        return <FontAwesomeIcon icon={faLock} fixedWidth={true} title="Denna registrering är gjord av en annan klinik och kan bara tas bort av den kliniken." style={helpStyle} />;
    }

    const hasContactInfo = !!(contributingPosition.data.POS_CONTACT_NAME
        || contributingPosition.data.POS_CONTACT_EMAIL
        || contributingPosition.data.POS_CONTACT_PHONE);

    const tooltip = (
        <Popover id={id}>
            <p>
                Denna registrering kan bara tas bort av <strong>{contributingPosition.data.PosNameWithCode}</strong>.
            </p>

            {!hasContactInfo && <em>Kontaktuppgifter till kliniken saknas.</em>}

            {hasContactInfo && (
                <div>
                    <div>Kontaktuppgifter:</div>
                    {contributingPosition.data.POS_CONTACT_NAME && <div>{contributingPosition.data.POS_CONTACT_NAME}</div>}
                    {contributingPosition.data.POS_CONTACT_EMAIL && <div>{contributingPosition.data.POS_CONTACT_EMAIL}</div>}
                    {contributingPosition.data.POS_CONTACT_PHONE && <div>{contributingPosition.data.POS_CONTACT_PHONE}</div>}
                </div>
            )}
        </Popover>
    );

    return (
        <OverlayTrigger overlay={tooltip}>
            <FontAwesomeIcon icon={faLock} fixedWidth={true} />
        </OverlayTrigger>
    );
};
